/* ==========================================================================
   Al Ustaz — custom section behaviour
   Vanilla, no dependencies. Loaded with defer from layout/theme.liquid.

   Add to cart is deliberately NOT handled here. Forms carry the
   .shopify-product-form class, which the theme's existing delegated ajax
   cart handler in colors.js already intercepts.
   ========================================================================== */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Quantity steppers
     ---------------------------------------------------------------------- */

  function stepQuantity(button) {
    var wrap = button.closest('.au-qty');
    if (!wrap) return;

    var input = wrap.querySelector('.au-qty__input');
    if (!input) return;

    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 999;
    var current = parseInt(input.value, 10) || min;
    var next = button.getAttribute('data-au-step') === 'up' ? current + 1 : current - 1;

    input.value = Math.min(Math.max(next, min), max);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ----------------------------------------------------------------------
     Add to cart button state
     colors.js only tracks buttons present at init, so cards rendered later
     need their own feedback.
     ---------------------------------------------------------------------- */

  function flagAdding(form) {
    var button = form.querySelector('[type="submit"]');
    if (!button) return;

    var original = button.getAttribute('data-au-label') || button.textContent.trim();
    button.setAttribute('data-au-label', original);
    button.classList.add('is-adding');
    button.textContent = button.getAttribute('data-au-adding-label') || original;

    window.setTimeout(function () {
      button.classList.remove('is-adding');
      button.classList.add('has-added');
      button.textContent = button.getAttribute('data-au-added-label') || original;

      window.setTimeout(function () {
        button.classList.remove('has-added');
        button.textContent = original;
      }, 2000);
    }, 600);
  }

  /* ----------------------------------------------------------------------
     Category filters (AU-4)
     Every group is already in the DOM. Switching is a class change, so
     there is no network request and no layout thrash.
     ---------------------------------------------------------------------- */

  function activateFilter(button) {
    var root = button.closest('.au-explorer');
    if (!root) return;

    var target = button.getAttribute('data-au-filter');

    root.querySelectorAll('[data-au-filter]').forEach(function (el) {
      var isMatch = el.getAttribute('data-au-filter') === target;
      el.classList.toggle('is-active', isMatch);
      if (el.tagName === 'BUTTON') {
        el.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      }
    });

    var select = root.querySelector('.au-explorer__select');
    if (select && select.value !== target) select.value = target;
  }

  function activateFilterFromSelect(select) {
    var root = select.closest('.au-explorer');
    if (!root) return;

    var button = root.querySelector('button[data-au-filter="' + select.value + '"]');
    if (button) activateFilter(button);
  }

  /* ----------------------------------------------------------------------
     Carousel arrows (AU-7)
     Scroll-snap does the work; the arrows just nudge scrollLeft.
     ---------------------------------------------------------------------- */

  function scrollCarousel(button) {
    var root = button.closest('.au-carousel');
    if (!root) return;

    var track = root.querySelector('.au-carousel__track');
    var slide = track && track.querySelector('.au-carousel__slide');
    if (!track || !slide) return;

    var step = slide.getBoundingClientRect().width + 16;
    var direction = button.getAttribute('data-au-scroll') === 'next' ? 1 : -1;

    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  function syncArrows(track) {
    var root = track.closest('.au-carousel');
    if (!root) return;

    var prev = root.querySelector('[data-au-scroll="prev"]');
    var next = root.querySelector('[data-au-scroll="next"]');
    var maxScroll = track.scrollWidth - track.clientWidth - 2;

    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= maxScroll;
  }

  /* ----------------------------------------------------------------------
     Hero cause selector (AU-1)
     ---------------------------------------------------------------------- */

  function syncHeroCta(select) {
    var root = select.closest('.au-hero');
    if (!root) return;

    var cta = root.querySelector('.au-hero__cta');
    if (!cta) return;

    var option = select.options[select.selectedIndex];
    var template = cta.getAttribute('data-label-template') || cta.textContent.trim();
    var fallback = cta.getAttribute('data-fallback-url') || '#';
    var url = option.getAttribute('data-url');
    var label = option.value || select.options[0].textContent.trim();

    cta.setAttribute('href', url && url.length ? url : fallback);
    cta.textContent = template.indexOf('[option]') > -1
      ? template.replace('[option]', label)
      : template;
  }

  // Picking a product in the hero selector goes straight to its page.
  // The default option (no value) stays put and keeps the button's fallback.
  function goToHeroChoice(select) {
    var option = select.options[select.selectedIndex];
    if (!option || !option.value) return;
    var url = option.getAttribute('data-url');
    if (url && url.length && url !== '#') window.location.href = url;
  }

  /* ----------------------------------------------------------------------
     Product hero variant picker (AU-P1)
     The theme's own variant JS does not bind to this section's pills, so
     picking an option never reached the hidden variant select: the price
     stayed put and Add to Cart always sent the first variant. This resolves
     the chosen options to a variant from the product JSON and updates the
     hidden select, the price, the buy button and the URL itself.
     ---------------------------------------------------------------------- */

  function syncPheroVariant(el) {
    var root = el.closest('.au-phero');
    if (!root) return;

    var sid = root.getAttribute('data-section-id');
    var json = document.getElementById('ProductJson-' + sid);
    if (!json) return;

    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return; }
    if (!product || !product.variants) return;

    var chosen = [];
    root.querySelectorAll('.au-phero__option').forEach(function (opt, i) {
      var radio = opt.querySelector('input[type="radio"]:checked');
      var sel = opt.querySelector('select');
      chosen[i] = radio ? radio.value : (sel ? sel.value : null);
    });

    var variant = null;
    for (var v = 0; v < product.variants.length; v++) {
      var candidate = product.variants[v];
      var match = candidate.options.every(function (value, i) {
        return chosen[i] == null || chosen[i] === value;
      });
      if (match) { variant = candidate; break; }
    }
    if (!variant) return;

    var select = document.getElementById('productSelect-' + sid);
    var priceText = null;
    if (select) {
      select.value = String(variant.id);
      var option = select.querySelector('option[value="' + variant.id + '"]');
      if (option) {
        var text = option.textContent;
        var cut = text.lastIndexOf(' - ');
        if (cut > -1) priceText = text.slice(cut + 3).trim();
      }
    }

    var priceEl = document.getElementById('productPrice-' + sid);
    if (priceEl && priceText) {
      var money = priceEl.querySelector('.money') || priceEl;
      if (money.textContent.trim() !== priceText) money.textContent = priceText;
    }

    var compareEl = document.getElementById('comparePrice-' + sid);
    if (compareEl) {
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.style.display = hasCompare ? '' : 'none';
    }

    var atc = document.getElementById('addToCart-' + sid);
    if (atc) atc.disabled = !variant.available;

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* ----------------------------------------------------------------------
     Reveal more supporter messages (AU-5)
     ---------------------------------------------------------------------- */

  function revealMessages(button) {
    var root = button.closest('.au-messages');
    if (!root) return;

    root.classList.add('is-expanded');
    button.remove();
  }

  /* ----------------------------------------------------------------------
     Copy link (product hero share)
     ---------------------------------------------------------------------- */

  function copyLink(button) {
    var url = button.getAttribute('data-au-copy');
    var label = button.querySelector('.au-share__label');
    if (!url || !label) return;

    var original = label.textContent;
    var done = function () {
      label.textContent = button.getAttribute('data-au-copied-label') || 'Copied';
      button.classList.add('is-copied');
      window.setTimeout(function () {
        label.textContent = original;
        button.classList.remove('is-copied');
      }, 1800);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () { fallbackCopy(url, done); });
    } else {
      fallbackCopy(url, done);
    }
  }

  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); done(); } catch (e) { /* ignore */ }
    document.body.removeChild(ta);
  }

  /* ----------------------------------------------------------------------
     Sticky buy bar (product hero)
     Shows once the card has scrolled out of view. Its quantity input mirrors
     the real one inside the form; its button submits that form via the
     form= attribute, so there is only ever one form — the one the
     PC - Product Options app injects into.
     ---------------------------------------------------------------------- */

  function initStickyBar(section) {
    var bar = section.querySelector('.au-bar');
    var card = section.querySelector('.au-phero__card');
    if (!bar || !card || section.getAttribute('data-au-sticky-bar') !== 'true') return;

    document.body.classList.add('au-has-bar');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !visible);
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }, { threshold: 0 });
      io.observe(card);
    } else {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }

    // Mirror quantity both ways
    var barQty = bar.querySelector('[data-au-bar-qty]');
    if (barQty) {
      var realQty = document.getElementById(barQty.getAttribute('data-au-bar-qty'));
      if (realQty) {
        barQty.addEventListener('change', function () { realQty.value = barQty.value; });
        realQty.addEventListener('change', function () { barQty.value = realQty.value; });
      }
    }

    // Mirror price when the theme's variant JS updates it
    var price = section.querySelector('[id^="productPrice-"]');
    var barPrice = bar.querySelector('[data-au-bar-price]');
    if (price && barPrice && 'MutationObserver' in window) {
      new MutationObserver(function () { barPrice.textContent = price.textContent.trim(); })
        .observe(price, { childList: true, subtree: true, characterData: true });
    }

    // Mirror disabled state of the real add-to-cart button
    var realAtc = section.querySelector('[id^="addToCart-"]');
    var barAtc = bar.querySelector('.au-bar__atc');
    if (realAtc && barAtc && 'MutationObserver' in window) {
      new MutationObserver(function () { barAtc.disabled = realAtc.disabled; })
        .observe(realAtc, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  function toggleBar(button) {
    var bar = button.closest('.au-bar');
    if (!bar) return;
    var open = bar.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ----------------------------------------------------------------------
     Delegated listeners — one set for the whole document
     ---------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-au-step]');
    if (step) {
      event.preventDefault();
      stepQuantity(step);
      return;
    }

    var filter = event.target.closest('[data-au-filter]');
    if (filter && filter.tagName === 'BUTTON') {
      event.preventDefault();
      activateFilter(filter);
      return;
    }

    var scroll = event.target.closest('[data-au-scroll]');
    if (scroll) {
      event.preventDefault();
      scrollCarousel(scroll);
      return;
    }

    var reveal = event.target.closest('[data-au-reveal]');
    if (reveal) {
      event.preventDefault();
      revealMessages(reveal);
      return;
    }

    var copy = event.target.closest('[data-au-copy]');
    if (copy) {
      event.preventDefault();
      copyLink(copy);
      return;
    }

    var barToggle = event.target.closest('[data-au-bar-toggle]');
    if (barToggle) {
      event.preventDefault();
      toggleBar(barToggle);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('.au-explorer__select')) {
      activateFilterFromSelect(event.target);
    }
    if (event.target.matches('.au-hero__select')) {
      syncHeroCta(event.target);
      goToHeroChoice(event.target);
    }
    if (event.target.matches('.au-phero__radios input, .au-phero__select')) {
      syncPheroVariant(event.target);
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target.matches('.au-card__form')) {
      flagAdding(event.target);
    }
  });

  /* ----------------------------------------------------------------------
     Initialisation, re-run on theme editor section load
     ---------------------------------------------------------------------- */

  function init(scope) {
    (scope || document).querySelectorAll('.au-hero__select').forEach(syncHeroCta);
    (scope || document).querySelectorAll('.au-phero').forEach(initStickyBar);

    // Browsers can restore a previously checked pill on back/forward; make
    // the hidden variant and price match whatever is checked on load.
    (scope || document).querySelectorAll('.au-phero__radios input:checked, .au-phero__select').forEach(syncPheroVariant);

    (scope || document).querySelectorAll('.au-carousel__track').forEach(function (track) {
      syncArrows(track);
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { syncArrows(track); });
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
